﻿import React from 'react';
import PropTypes from 'prop-types';

import theme from "./PersonalMessage.module.sass";

const PersonalMessage = ({
  message = '',
}) => (
  <div className={theme.PersonalMessage} dangerouslySetInnerHTML={{ __html: message }} />
);

PersonalMessage.propTypes = {
  message: PropTypes.string,
};

export default PersonalMessage;
